module.exports = __webpack_public_path__ + "static/media/jili-slots.cc8a85b6.webp";